import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formatea un número como pesos colombianos (COP).
 * Ejemplo: 25000 → "$ 25.000"
 */
@Pipe({
  name: 'currencyCop',
  standalone: true
})
export class CurrencyCopPipe implements PipeTransform {
  transform(value: number | null | undefined, decimals: number = 0): string {
    if (value == null || typeof value !== 'number') return '$ 0';
    return '$ ' + value.toLocaleString('es-CO', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  }
}
